import { createFileRoute, notFound } from '@tanstack/react-router'
import InvoicePageHeader from '../../Pages/InvoicePage/InvoicePageHeader'
import InvoicePage from '../../Pages/InvoicePage/InvoicePage'
import PageBody from '../../Pages/Layout/PageBody'
import { processTRPCData } from '../../Queries/fetchData'
import LoadingSpinner from '../../Components/LoadingSpinner'
import ErrorComponent from '../../Components/ErrorComponent'
import {
    canViewRoute,
    migratedToV2,
} from '../../State/Permissions/HasPermissions'
import SessionStore from '../../State/SessionStore'
import PermissionDenied from '../../Pages/PermissionDenied'
import DataStore from '../../State/DataStore'
import { router } from '../../App'
import InvoiceCollection from '../../State/Collections/InvoiceCollection'
import { setLayoutDefaults } from '@2/layout/layout-store'
import { getCacheItemById } from '@2/cache'
import { CenterPadPageBody } from '@2/layout/page-body'
import { trpc } from '../../system/trpc'
import OrganisationCollection from '../../State/Collections/OrganisationCollection'
import { cleanupNewEntity } from '../../Utils/deleteEntity'

export const Route = createFileRoute('/_private/invoices/$id/')({
    beforeLoad: ({ params }) => {
        if (!canViewRoute(SessionStore.user, 'invoice', params))
            throw new Error('Permission Denied')
        const invoice = getCacheItemById('invoices', params.id)
        setLayoutDefaults({
            pageTitle: invoice?.ref || 'Invoice',
            subMenu: 'invoices',
            tabs: [
                {
                    id: 'details',
                    label: 'Details',
                    url: `/invoices/${params.id}`,
                },
                {
                    id: 'pdf',
                    label: 'PDF',
                    url: `/invoices/${params.id}/pdf`,
                },
            ],
        })
    },
    errorComponent: ({ error, reset }) => {
        if (error.message === 'Permission Denied') return <PermissionDenied />
        return <ErrorComponent error={error} reset={reset} />
    },
    loader: async ({ params }) => await loader(params.id),
    pendingComponent: LoadingSpinner,
    component: Wrapper,
    onLeave: (match) => {
        const { id } = match.params
        const invoice = InvoiceCollection.invoicesById[id]
        if (
            invoice &&
            !invoice.createdAt &&
            match.pathname !== router.latestLocation.pathname
        ) {
            cleanupNewEntity(invoice, 'invoice')
        }
    },
})

const loader = async (id) => {
    const data = await trpc.legacy.getInvoicePageData.query({ id })
    const processedModels = processTRPCData(data)
    const invoice =
        InvoiceCollection.invoicesById[id] ||
        InvoiceCollection.invoicesByOldId[id]
    if (!invoice) {
        throw notFound()
    }
    return processedModels
}

function Wrapper() {
    const { id } = Route.useParams()
    if (migratedToV2()) {
        return (
            <CenterPadPageBody>
                <InvoicePage id={id} />
            </CenterPadPageBody>
        )
    }
    return (
        <>
            <InvoicePageHeader id={id} />
            <PageBody>
                <InvoicePage id={id} />
            </PageBody>
        </>
    )
}
